/**
 * Modifications to the homepage.
 */

jQuery(($) => {
  if ($('body').hasClass('page-homepage')) {
    const $scrollTop = $(window).scrollTop();

    if ($scrollTop >= 75 && !$('.site-header').hasClass('scrolled')) {
      $('.site-header').addClass('scrolled');
    } else if ($scrollTop < 75 && $('.site-header').hasClass('scrolled')) {
      $('.site-header').removeClass('scrolled');
    }

    $(window).on('scroll', () => {
      // TODO: already defined above. Is this a different, updated, value?
      // const $scrollTop = $(window).scrollTop();

      if ($scrollTop >= 75 && !$('.site-header').hasClass('scrolled')) {
        $('.site-header').addClass('scrolled');
      } else if ($scrollTop < 75 && $('.site-header').hasClass('scrolled')) {
        $('.site-header').removeClass('scrolled');
      }
    });
  }
});
